import { render, staticRenderFns } from "./VirtualTransferDemo.vue?vue&type=template&id=b560d732&scoped=true&"
import script from "./VirtualTransferDemo.vue?vue&type=script&lang=js&"
export * from "./VirtualTransferDemo.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTransferDemo.vue?vue&type=style&index=0&id=b560d732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b560d732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b560d732')) {
      api.createRecord('b560d732', component.options)
    } else {
      api.reload('b560d732', component.options)
    }
    module.hot.accept("./VirtualTransferDemo.vue?vue&type=template&id=b560d732&scoped=true&", function () {
      api.rerender('b560d732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/VirtualTransferDemo.vue"
export default component.exports